import { CoreConfig } from '@/configs/core/core.config';
import { ERRORS } from '@/constants/error';
import { useAppContext } from '@/providers/app-provider/app-provider';

const useCoreConfig = (): CoreConfig => {
  const context = useAppContext<{ coreConfig?: CoreConfig }>();
  if (!context?.coreConfig) {
    throw ERRORS.REGULAR('coreConfig could not be found');
  }

  return context.coreConfig;
};

export default useCoreConfig;
